export const VAULT_CREATE_KYB_KYC_SUBMIT_QUERY = `
mutation VaultCreateKybKycSubmit(
    $rawOrgData: VaultKybCreateInput!,
    $rawRepresentativeData: VaultRepresentativeCreateInput!,
    $stripeData: VaultCreateKybKycStripeInput,
    $gateway: VaultFinancialProvider!,
    $saveToPayableOrgId: ID,
    $rawBeneficialOwners: [VaultKycCreateInput!]
  ) {
    vaultCreateKybKycSubmit(
      orgData: $rawOrgData,
      representativeData: $rawRepresentativeData,
      stripeData: $stripeData,
      gateway: $gateway,
      saveToPayableOrgId: $saveToPayableOrgId,
      beneficialOwners: $rawBeneficialOwners
    ) {
      success
      successData {
        kybData {
          kybId
          orgId
          financialAccountId
          stripeConnectAccountId
        }
        representative {
          kycId
          userId
          stripePersonId
        }
        beneficialOwners {
          kycId
          userId
          stripePersonId
        }
        payableOrgNode {
          kybData {
            kybId
            orgId
            financialAccountId
            stripeConnectAccountId
          }
          representative {
            kycId
            userId
            stripePersonId
          }
          beneficialOwners {
            kycId
            userId
            stripePersonId
          }
        }
      }
      errors {
        message
        type
        field
        retryable
        fieldMessage
      }
    }
  }
`;
